import { render, staticRenderFns } from "./SHXTO.vue?vue&type=template&id=ba534392&scoped=true&"
import script from "./SHXTO.vue?vue&type=script&lang=js&"
export * from "./SHXTO.vue?vue&type=script&lang=js&"
import style0 from "./SHXTO.vue?vue&type=style&index=0&id=ba534392&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba534392",
  null
  
)

export default component.exports